/* eslint-env browser */

/*
  TODO:
  - Refactor this to support shell page experiment https://jira.groupondev.com/browse/DEAL-5260
*/

'use strict';

const logError = require('./log_error');

const { documentReady, windowLoaded } = require('@grpn/document-states');

const scheduleJs = (fn, timeout = 1000) => {
  if (process.env.NODE_ENV !== 'production') {
    if (window.payload.nodeEnv === 'test') {
      return fn();
    }
  }

  if (window.requestIdleCallback) {
    return window.requestIdleCallback(fn, { timeout });
  } else {
    return window.setTimeout(fn, 0);
  }
};

const makeInitModule = payload => {
  // TODO: refactor modules to remove done()
  const doneShim = () => {};
  return (module, name) => {
    try {
      return module.init(payload, doneShim);
    } catch (e) {
      const errorMessage = `module ${name} failed to initialize`;
      const error = e || new Error(errorMessage);
      return logError(error, 'DealPage-FrontEndInit-Error', errorMessage, name);
    }
  };
};

/*
  Initialize Frontend Javascript
  - jsInitializer is immediately invoked so only one instance exists on page
*/
const jsInitializer = (() => {
  const criticalJS = new Map();
  const pageReadyJS = new Map();
  const nonCriticalJS = new Map();

  const initialize = () => {
    const payload = window.payload;
    const initModule = makeInitModule(payload);

    // always runs after document ready
    documentReady.then(() => {
      criticalJS.forEach(initModule);
    });

    // always runs after window load
    windowLoaded.then(() => {
      pageReadyJS.forEach(initModule);
      scheduleJs(() => nonCriticalJS.forEach(initModule));
    });
  };

  const addToMap = (currentMap, newFiles) => {
    const { moduleList } = window.payload.jsInitializer;
    const modulesToInit = new Map(moduleList.map(file => [file, true]));
    newFiles.forEach(({ name, module }) => {
      if (modulesToInit.has(name)) {
        currentMap.set(name, module);
      }
    });
  };

  return {
    /*
      add module objs to be executed

      @params {array} [crit] - critical js to be immediately executed
      @params {array} [nonCrit] - js that when be executed when the browser is idle
      @params {array} [pageReady] - js used to mark t_done, etc
    */
    addJsFiles(crit = [], nonCrit = [], pageReady = []) {
      addToMap(criticalJS, crit);
      addToMap(nonCriticalJS, nonCrit);
      addToMap(pageReadyJS, pageReady);

      return this;
    },

    /*
      check if we're ready to initialize all passed-in JS

      @params {string} [initName]
        - name of js file, e.g. "responsive_local"
        - should be the last Deal Page file loaded
    */
    initialize,
  };
})();

module.exports = jsInitializer;
